export default __webpack_public_path__ + "static/about_vibe-5bf05c45ec6171fdf572025d342c5fb1.webp";